import debounce from 'lodash.debounce';
import type { Map as MapType } from 'mapbox-gl';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import IconButton from '@alltrails/denali/components/IconButton';
import CompassIcon from '@alltrails/denali/icons/Compass';
import useMap from '../../hooks/useMap';
import styles from './styles/styles.module.scss';

type RotateEventHandler = (event: { type: 'rotate'; target: MapType }) => void;

type CompassButtonProps = {
  onClick?: () => void;
};

const CompassButton = ({ onClick }: CompassButtonProps) => {
  const intl = useIntl();
  const map = useMap();
  const [bearing, setBearing] = useState((map?.getBearing() || 0) * -1);

  useEffect(() => {
    const onRotate = debounce<RotateEventHandler>(({ target: updatedMap }) => {
      // Multiply by -1 since the compass is pointing at the _opposite_ of the
      // current bearing of the map.
      setBearing(updatedMap.getBearing() * -1);
    }, 100);

    map?.on('rotate', onRotate);

    return () => {
      map?.off('rotate', onRotate);
    };
  }, [map]);

  return bearing === 0 ? null : (
    <IconButton
      className={styles.compass}
      icon={{ Component: CompassIcon, orientation: bearing }}
      onClick={() => {
        onClick?.();
        map?.resetNorth();
      }}
      title={intl.formatMessage({ defaultMessage: 'Reset north' })}
      variant="elevated"
    />
  );
};

export default CompassButton;
